/*
  Tablya : simulateurs de taille, sans dépendance.
  Reprend le script de la maquette (design/maquette/index.html et produit.html).

  <tablya-taille>     sections/tablya-taille.liquid
    Longueur conseillée = base + (convives - min) × pas (maquette : 120 + (n - 4) × 20 cm).
    Plateau centré, chaises réparties sur les côtés, une en bout dès 5 convives, deux dès 6.

  <tablya-rallonges>  sections/tablya-rallonges.liquid
    Longueur = longueur fermée + n × longueur d'une rallonge ; toutes rallonges sorties, le champ méta
    longueur_ouverte_cm (data-ouverte) s'il est rempli, pour ne jamais contredire la fiche technique.
    Couverts = 2 × floor(longueur / 60) + 2 (60 cm par convive, le repère affiché sur le site),
    plafonnés au champ méta personnes_max s'il est rempli.
    Mode console : mur à gauche, fermée elle s'y adosse (pas de couvert) ; ouverte, on l'écarte pour la chaise du bout.
    Mode table : pas de mur, les couverts se comptent aussi table fermée.

  Chaque élément lit ses données dans ses attributs data-* et redessine le plan à chaque mouvement du curseur.
  Le plateau glisse grâce aux transitions CSS (x, width), coupées si « réduire les animations » est actif.
  Le script peut être chargé deux fois (une balise par section) : les éléments ne sont définis qu'une fois.
*/
(function () {
  'use strict';

  if (!window.customElements) return;

  var SVG = 'http://www.w3.org/2000/svg';

  function nombre(valeur, secours) {
    var n = parseFloat(valeur);
    return isFinite(n) ? n : secours;
  }

  function arrondi(n) {
    return Math.round(n * 100) / 100;
  }

  // 120 → « 120 », 120.5 → « 120,5 »
  function cm(n) {
    return String(Math.round(n * 10) / 10).replace('.', ',') + ' cm';
  }

  function chaise(x, y, largeur, hauteur) {
    var r = document.createElementNS(SVG, 'rect');
    r.setAttribute('class', 'tb-simu__chaise');
    r.setAttribute('x', arrondi(x));
    r.setAttribute('y', y);
    r.setAttribute('width', largeur);
    r.setAttribute('height', hauteur);
    r.setAttribute('rx', 6);
    return r;
  }

  // Le style CSS porte la transition, l'attribut sert de repli aux navigateurs qui n'animent pas x / width
  function placerPlateau(rect, x, w) {
    x = arrondi(x);
    w = arrondi(w);
    rect.style.x = x + 'px';
    rect.style.width = w + 'px';
    rect.setAttribute('x', x);
    rect.setAttribute('width', w);
  }

  function placerCote(ligne, texte, x, w, xTexte, longueur) {
    if (ligne) {
      ligne.setAttribute('x1', arrondi(x));
      ligne.setAttribute('x2', arrondi(x + w));
    }
    if (texte) {
      texte.setAttribute('x', arrondi(xTexte));
      texte.textContent = cm(longueur);
    }
  }

  function remplacer(groupe, fragment) {
    while (groupe.firstChild) groupe.removeChild(groupe.firstChild);
    groupe.appendChild(fragment);
  }

  function ecrire(el, texte) {
    if (el) el.textContent = texte;
  }

  /* ---------- Quelle taille choisir (accueil) ---------- */
  class TablyaTaille extends HTMLElement {
    connectedCallback() {
      if (this.pret) return;
      this.curseur = this.querySelector('[data-curseur]');
      this.plateau = this.querySelector('[data-plateau]');
      this.chaises = this.querySelector('[data-chaises]');
      if (!this.curseur || !this.plateau || !this.chaises) return;
      this.pret = true;

      this.cote = this.querySelector('[data-cote]');
      this.coteTexte = this.querySelector('[data-cote-texte]');
      this.sortieNb = this.querySelector('[data-nb]');
      this.sortieLongueur = this.querySelector('[data-longueur]');

      this.min = nombre(this.curseur.min, 4);
      this.max = nombre(this.curseur.max, 12);
      this.base = nombre(this.dataset.base, 120);
      this.pas = nombre(this.dataset.pas, 20);
      this.unite = this.dataset.unite || 'personnes';

      // Échelle de la maquette (1,2 px par cm), réduite si la plus longue table ne tient pas dans le dessin
      var longueurMax = this.base + (this.max - this.min) * this.pas;
      this.echelle = longueurMax > 0 ? Math.min(1.2, 336 / longueurMax) : 1.2;

      this.curseur.addEventListener('input', this.dessiner.bind(this));
      this.dessiner();
    }

    dessiner() {
      var n = Math.round(nombre(this.curseur.value, this.min));
      var longueur = this.base + (n - this.min) * this.pas;
      var texteNb = n + ' ' + this.unite;

      ecrire(this.sortieNb, texteNb);
      ecrire(this.sortieLongueur, cm(longueur));
      this.curseur.setAttribute('aria-valuetext', texteNb);

      var w = Math.max(longueur * this.echelle, 0);
      var x = (440 - w) / 2;
      placerPlateau(this.plateau, x, w);
      placerCote(this.cote, this.coteTexte, x, w, 220, longueur);

      // Chaises : une en bout dès 5 convives, deux dès 6, le reste réparti sur les deux côtés
      var bouts = n >= 6 ? 2 : n === 5 ? 1 : 0;
      var cotes = Math.max(n - bouts, 0);
      var haut = Math.ceil(cotes / 2);
      var bas = cotes - haut;
      var fragment = document.createDocumentFragment();

      function rangee(k, y) {
        for (var i = 0; i < k; i++) {
          var cx = x + (w * (i + 0.5)) / k;
          fragment.appendChild(chaise(cx - 16, y, 32, 24));
        }
      }

      rangee(haut, 38);
      rangee(bas, 158);
      if (bouts >= 1) fragment.appendChild(chaise(x - 34, 98, 24, 24));
      if (bouts === 2) fragment.appendChild(chaise(x + w + 10, 98, 24, 24));
      remplacer(this.chaises, fragment);
    }
  }

  /* ---------- De console à table (fiche produit) ---------- */
  class TablyaRallonges extends HTMLElement {
    connectedCallback() {
      if (this.pret) return;
      this.curseur = this.querySelector('[data-curseur]');
      this.plateau = this.querySelector('[data-plateau]');
      this.chaises = this.querySelector('[data-chaises]');
      if (!this.curseur || !this.plateau || !this.chaises) return;

      this.fermee = nombre(this.dataset.fermee, 0);
      this.rallonge = nombre(this.dataset.rallonge, 0);
      this.nb = nombre(this.curseur.max, 0);
      if (this.fermee <= 0 || this.rallonge <= 0 || this.nb <= 0) return;
      this.pret = true;

      this.console = this.dataset.mode !== 'table';
      this.ouverte = nombre(this.dataset.ouverte, 0);
      this.personnesMax = nombre(this.dataset.personnesMax, 0);
      this.singulier = this.dataset.singulier || 'rallonge';
      this.pluriel = this.dataset.pluriel || 'rallonges';
      this.usageFerme = this.dataset.usageFerme || '';
      this.usageOuvert = this.dataset.usageOuvert || '';
      this.vide = this.dataset.vide || '—';

      this.mur = this.querySelector('[data-mur]');
      this.cote = this.querySelector('[data-cote]');
      this.coteTexte = this.querySelector('[data-cote-texte]');
      this.sortieNb = this.querySelector('[data-nb]');
      this.sortieLongueur = this.querySelector('[data-longueur]');
      this.sortieCouverts = this.querySelector('[data-couverts]');
      this.sortieUsage = this.querySelector('[data-usage]');
      this.points = Array.prototype.slice.call(this.querySelectorAll('[data-points] i'));

      // Échelle de la maquette (1,4 px par cm), réduite si la table ouverte ne tient pas dans le dessin
      var longueurMax = Math.max(this.fermee + this.nb * this.rallonge, this.ouverte);
      this.echelle = Math.min(1.4, 330 / longueurMax);

      // Vraie largeur du plateau (même échelle que la longueur) et bouts arrondis pour les rondes et ovales
      var largeur = nombre(this.dataset.largeur, 0);
      this.h = largeur > 0 ? Math.max(60, Math.min(160, largeur * this.echelle)) : 140;
      this.y = 125 - this.h / 2;
      this.arrondi = this.dataset.arrondi === '1';

      this.curseur.addEventListener('input', this.dessiner.bind(this));
      this.dessiner();
    }

    dessiner() {
      var n = Math.round(nombre(this.curseur.value, 0));
      var longueur = this.fermee + n * this.rallonge;
      if (n >= this.nb && this.ouverte > this.fermee) longueur = this.ouverte;
      var w = longueur * this.echelle;
      // Vue de dessus, mur à gauche : fermée, la console s'y adosse ; ouverte, on l'écarte pour la chaise du bout
      var x = this.console && !n ? 29 : 66;

      var assis = n > 0 || !this.console;
      var parCote = assis ? Math.floor(longueur / 60) : 0;
      var couverts = assis ? parCote * 2 + 2 : 0;
      if (couverts && this.personnesMax > 0) couverts = Math.min(couverts, this.personnesMax);

      var texteNb = n + ' ' + (n > 1 ? this.pluriel : this.singulier);
      ecrire(this.sortieNb, texteNb);
      this.curseur.setAttribute('aria-valuetext', texteNb);
      ecrire(this.sortieLongueur, cm(longueur));
      ecrire(this.sortieCouverts, couverts ? String(couverts) : this.vide);
      if (this.console) ecrire(this.sortieUsage, n ? this.usageOuvert : this.usageFerme);

      this.points.forEach(function (point, i) {
        point.classList.toggle('on', i < n);
      });

      placerPlateau(this.plateau, x, w);
      var r = this.arrondi ? Math.min(this.h, w) / 2 : 6;
      this.plateau.setAttribute('y', arrondi(this.y));
      this.plateau.setAttribute('height', arrondi(this.h));
      this.plateau.setAttribute('rx', arrondi(r));
      this.plateau.setAttribute('ry', arrondi(r));
      if (this.mur) this.mur.style.opacity = n ? 0.25 : 1;
      placerCote(this.cote, this.coteTexte, x, w, x + w / 2, longueur);

      // Chaises : deux en bout, le reste réparti sur les deux côtés (sans plafond : floor(longueur / 60) par côté)
      var bouts = Math.min(couverts, 2);
      var cotes = couverts - bouts;
      var haut = Math.ceil(cotes / 2);
      var bas = cotes - haut;
      var fragment = document.createDocumentFragment();

      // Chaises le long de la partie droite du plateau (hors bouts arrondis), collées au bord haut et bas
      // Ronde ou ovale : chaises réparties sur les 60 % centraux du plateau, pour qu'elles ne se chevauchent pas
      var xd = this.arrondi ? x + w * 0.2 : x, wd = this.arrondi ? w * 0.6 : w;
      var yHaut = this.y - 32, yBas = this.y + this.h + 6;
      function rangee(k, y) {
        for (var i = 0; i < k; i++) {
          var cx = xd + (wd * (i + 0.5)) / k;
          fragment.appendChild(chaise(cx - 17, y, 34, 26));
        }
      }

      rangee(haut, yHaut);
      rangee(bas, yBas);
      if (bouts >= 1) fragment.appendChild(chaise(x - 36, 108, 26, 34));
      if (bouts === 2) fragment.appendChild(chaise(x + w + 10, 108, 26, 34));
      remplacer(this.chaises, fragment);
    }
  }

  if (!customElements.get('tablya-taille')) customElements.define('tablya-taille', TablyaTaille);
  if (!customElements.get('tablya-rallonges')) customElements.define('tablya-rallonges', TablyaRallonges);
})();
